import { render, staticRenderFns } from "./ModalMapClosingComponent.vue?vue&type=template&id=645a01eb&"
import script from "./ModalMapClosingComponent.vue?vue&type=script&lang=js&"
export * from "./ModalMapClosingComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalMapClosingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports